export default function getAdminAuthorization(isAdmin, isSelectraAdmin, key) {
  switch (key) {
    case 'home':
    case 'overview':
    case 'form':
    case 'clientCallbacks':
    case 'search':
    case 'logout':
      return true
    case 'users':
      return isAdmin
    case 'ipAddresses':
    case 'assistanceProducts':
    case 'monConseillerPersoProducts':
    case 'carbonOffset':
    case 'servicesStatus':
    case 'providerOptions':
    case 'providers':
    case 'devTools':
    case 'offices':
    case 'additionalSales':
      return isSelectraAdmin
  }
}
